import { Component } from '@angular/core';

@Component({
  selector: 'csgofast-possible-card-mock',
  templateUrl: './possible-card.component.mock.html',
  styleUrls: ['./possible-card.component.mock.scss', '../possible-card.component.scss'],
})
export class PossibleCardMockComponent {
}
